import { render } from "./Streaming.vue?vue&type=template&id=b1807a20&scoped=true"
import script from "./Streaming.vue?vue&type=script&lang=js"
export * from "./Streaming.vue?vue&type=script&lang=js"

import "./Streaming.vue?vue&type=style&index=0&id=b1807a20&lang=scss&scoped=true"

import exportComponent from "/Users/amina/Desktop/streamup_amina/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1807a20"]])

export default __exports__